import React from "react";

export default function SearchBar({ searchHandler, keyHandler, value, placeholder = "search" }) {
  return (
    <div className='input-group'>
      <div className='form-outline'>
        <input
          type='search'
          id='searchForm'
          className='form-control'
          {...(value !== undefined ? { value } : {})}
          autoComplete='off'
          autoCorrect='off'
          autoCapitalize='off'
          spellCheck='false'
          placeholder={placeholder}
          onKeyDown={keyHandler}
          onChange={(e) => {
            searchHandler(e.target.value);
          }}
        />
      </div>
    </div>
  );
}
